import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { makeStyles } from "@material-ui/core/styles";

import SelectedList from "../../Components/List/SelectedList";

const AssetListPanel = (props) => {
  // Hooks
  const navigation = useNavigate();
  const classes = useStyles();
  const location = useLocation();

  // Redux state
  const selectedAssets = useSelector((state) => state.task.selectedAssets);
  const { mode, taskId } = useSelector((state) => state.task);

  // Route redirect function
  const goTo = () => {
    if (mode == "create") {
      if (location.pathname.includes("Library")) {
        navigation("/Task/CreateDetail/library");
      } else {
        navigation("/Task/CreateDetail/assets");
      }
    }
    if (mode == "edit") {
      if (location.pathname.includes("Library")) {
        navigation(`/Task/EditDetail/${taskId}/library`);
      } else {
        navigation(`/Task/EditDetail/${taskId}/assets`);
      }
    }
  };

  const goToView = (id) => {
    navigation(`/Task/AssetView/${id}`);
  };

  return (
    <Grid
      item
      xs={5}
      sx={{
        display: selectedAssets && selectedAssets.length == 0 ? "flex" : "",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F5F7FF",
        overflow: "auto",
        width: "100%",
        borderRadius: 5,
        height: "75vh",
        paddingTop: selectedAssets && selectedAssets.length == 0 ? "" : 5,
      }}
    >
      {selectedAssets && selectedAssets.length == 0 && (
        <Box sx={{ textAlign: "center" }}>
          {/* <img src={require("../../assets/Assign_place.png")} width="50%" /> */}
          <Typography
            sx={{
              color: "#A9A9A9",
              fontWeight: 600,
              fontSize: "0.9rem",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
              },
            }}
          >
            This is where you'll see all your added assets
          </Typography>
        </Box>
      )}

      <Box
        sx={{ height: "58vh", overflowY: "auto" }}
         
      >
        {selectedAssets &&
          selectedAssets.length > 0 &&
          selectedAssets.map((val, index) => {
            return (
              <div key={`${index}_selectedAssets`}>
                <SelectedList
                  data={{
                    name: `${index + 1}. ${
                      val.name.includes(".")
                        ? val.name.split(".")[1]?.trim()
                        : val.name
                    }`,
                    id: val.id,
                  }}
                  viewaction={
                    location && location.pathname.includes("Library")
                      ? false
                      : true
                  }
                  view={() => {
                    goToView(val.id);
                  }}
                ></SelectedList>
              </div>
            );
          })}
      </Box>
      {selectedAssets && selectedAssets.length > 0 && (
        <Button
          variant="contained"
          size="small"
          sx={{
            px: 5,
            ml: 3,
            mt: 2,
            borderRadius: 15,
            backgroundColor: "primary.main",
            color: "#FFFFFF",
            height: "2rem",
            textTransform: "inherit",
           
            alignSelf: "baseline",
          }}
          onClick={() => {
            goTo();
          }}
        >
          Create Task
        </Button>
      )}
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssetListPanel;
